import { render } from "./AssignRoleModal.vue?vue&type=template&id=aa51e1be&scoped=true"
import script from "./AssignRoleModal.vue?vue&type=script&lang=js"
export * from "./AssignRoleModal.vue?vue&type=script&lang=js"

import "./AssignRoleModal.vue?vue&type=style&index=0&id=aa51e1be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa51e1be"]])

export default __exports__